// Translations in Italian
const translations = {
  Upload: "Caricare",
  "Select Header": "Seleziona intestazione",
  "Map Columns": "Mappa colonne",
  "Expected Column": "Colonna prevista",
  Required: "Richiesto",
  "Drop your file here": "Trascina il tuo file qui",
  or: "oppure",
  "Browse files": "Sfoglia file",
  "Download Template": "Scarica il modello",
  "Only CSV, TSV, XLS, and XLSX files can be uploaded": "Solo i file CSV, TSV, XLS e XLSX possono essere caricati",
  "Select Header Row": "Seleziona la riga di intestazione",
  "Select the row which contains the column headers": "Seleziona la riga che contiene le intestazioni delle colonne",
  "Only the first sheet (&quot;{{sheet}}&quot;) of the Excel file will be imported. To import multiple sheets, please upload each sheet individually.": "Solo il primo foglio (&quot;{{sheet}}&quot;) del file Excel verrà importato. Per importare più fogli, carica ogni foglio singolarmente.",
  "Cancel": "Annulla",
  "Continue": "Continua",
  "Your File Column": "La tua colonna di file",
  "Your Sample Data": "I tuoi dati di esempio",
  "Destination Column": "Colonna di destinazione",
  "Include": "Includere",
  "Submit": "Invia",
  "Loading...": "Caricamento...",
  "Please include all required columns": "Si prega di includere tutte le colonne richieste",
  "Back": "Indietro",
  "- Select one -": "- Selezionane uno -",
  "- empty -": "- vuoto -",
  "Import Successful": "Importazione riuscita",
  "Upload Successful": "Caricamento riuscito",
  "Done": "Fatto",
  "Upload another file": "Carica un altro file",
};

export default translations;
